import { useEffect, useRef, useState } from "react";
import { getApiService } from "../services/api";

export interface LivePrice {
  price: number | null;
  percent: number | null;
}

// 每秒刷新实时价格（涨跌幅），用于持仓列表与加仓/减仓对话框
export function useLivePrice(code: string | undefined, enabled = true): LivePrice {
  const [price, setPrice] = useState<LivePrice>({ price: null, percent: null });
  const mounted = useRef(true);

  useEffect(() => {
    mounted.current = true;
    if (!code || !enabled) return;

    let timer: ReturnType<typeof setInterval> | null = null;
    const fetchPrice = async () => {
      try {
        const { price: p, percent: pc } = await getApiService().getStockPrice(code);
        if (mounted.current) setPrice({ price: p, percent: pc });
      } catch {
        // 上游接口异常时保持上次价格，不打断轮询
      }
    };

    fetchPrice();
    timer = setInterval(fetchPrice, 1000);
    return () => {
      mounted.current = false;
      if (timer) clearInterval(timer);
    };
  }, [code, enabled]);

  return price;
}
